export let S3GatewayPath = /*#__PURE__*/function (S3GatewayPath) {
  S3GatewayPath["orderInvoices"] = "orderInvoices";
  S3GatewayPath["warehousingFeeInvoices"] = "warehousingFeeInvoices";
  S3GatewayPath["shipoutInvoices"] = "shipoutInvoices";
  S3GatewayPath["csvFileToSend"] = "csvFileToSend";
  S3GatewayPath["adminAttachments"] = "adminAttachments";
  S3GatewayPath["tenantInvoices"] = "tenantInvoices";
  return S3GatewayPath;
}({});